import FormContainer from "../../../components/formContainer/FormContainer";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import { useLanguageContext } from "../../../context/LanguageContext";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../styles/LayoutStyles";
import { StyledInput } from "../../../styles/InputStyles";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import Select from "../../../components/select/main/Select";
import { useTheme } from "styled-components";
import SaltoLocks from "./locks/SaltoLocks";
import SaltoIqs from "./iqs/SaltoIqs";
import SaltoVisitorTypes from "./visitor_types/SaltoVisitorTypes";

function SaltoConfigsPageView({
  configData,
  saltoResources,
  visitorTypes,
  setConfigData,
  onActiveChange,
  onClientIdChange,
  onClientSecretChange,
  onUsernameChange,
  onPasswordChange,
  onApiUrlChange,
  onAuthUrlChange,
  onSyncEmployeesChange,
  onSyncVisitorsChange,
  onSubmit,
  submitError,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn style={{ gap: theme.spacing.large }}>
      <OverlayLoader groups="salto_configs_page_fetch">
        <FormContainer
          onSubmit={onSubmit}
          submitError={submitError}
          submitLoadingGroup={"salto_configs_page_save"}
        >
          <StyledFlexColumn>
            <InputWrapper
              label={translate("eva.main.validation.attributes.active")}
              required
              error={EVAApiHelper.getResponseError("active", submitError)}
            >
              <Select
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                value={configData.active}
                onChange={onActiveChange}
              />
            </InputWrapper>

            <StyledFlexRow>
              <StyledFlexItem>
                <InputWrapper
                  label={translate("eva.main.validation.attributes.client_id")}
                  required
                  error={EVAApiHelper.getResponseError(
                    "client_id",
                    submitError,
                  )}
                >
                  <StyledInput
                    type="text"
                    placeholder={translate(
                      "eva.main.validation.attributes.client_id",
                    )}
                    value={configData.client_id}
                    onChange={onClientIdChange}
                  />
                </InputWrapper>
              </StyledFlexItem>

              <StyledFlexItem>
                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.client_secret",
                  )}
                  required
                  error={EVAApiHelper.getResponseError(
                    "client_secret",
                    submitError,
                  )}
                >
                  <StyledInput
                    type="text"
                    placeholder={translate(
                      "eva.main.validation.attributes.client_secret",
                    )}
                    value={configData.client_secret}
                    onChange={onClientSecretChange}
                  />
                </InputWrapper>
              </StyledFlexItem>
            </StyledFlexRow>

            <StyledFlexRow>
              <StyledFlexItem>
                <InputWrapper
                  label={translate("eva.main.validation.attributes.username")}
                  required
                  error={EVAApiHelper.getResponseError("username", submitError)}
                >
                  <StyledInput
                    type="text"
                    placeholder={translate(
                      "eva.main.validation.attributes.username",
                    )}
                    value={configData.username}
                    onChange={onUsernameChange}
                  />
                </InputWrapper>
              </StyledFlexItem>

              <StyledFlexItem>
                <InputWrapper
                  label={translate("eva.main.validation.attributes.password")}
                  required
                  error={EVAApiHelper.getResponseError("password", submitError)}
                >
                  <StyledInput
                    type="text"
                    placeholder={translate(
                      "eva.main.validation.attributes.password",
                    )}
                    value={configData.password}
                    onChange={onPasswordChange}
                  />
                </InputWrapper>
              </StyledFlexItem>
            </StyledFlexRow>

            <InputWrapper
              label={translate("eva.main.validation.attributes.api_url")}
              required
              error={EVAApiHelper.getResponseError("api_url", submitError)}
            >
              <StyledInput
                type="text"
                placeholder={"https://clp-accept-user.saltoks.com"}
                value={configData.api_url}
                onChange={onApiUrlChange}
              />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.auth_url")}
              required
              error={EVAApiHelper.getResponseError("auth_url", submitError)}
            >
              <StyledInput
                type="text"
                placeholder={"https://identity-acc.eu.my-clay.com"}
                value={configData.auth_url}
                onChange={onAuthUrlChange}
              />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.sync_employees")}
              required
              error={EVAApiHelper.getResponseError(
                "sync_employees",
                submitError,
              )}
            >
              <Select
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                value={configData.sync_employees}
                onChange={onSyncEmployeesChange}
              />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.sync_visitors")}
              required
              error={EVAApiHelper.getResponseError(
                "sync_visitors",
                submitError,
              )}
            >
              <Select
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                value={configData.sync_visitors}
                onChange={onSyncVisitorsChange}
              />
            </InputWrapper>
          </StyledFlexColumn>
        </FormContainer>
      </OverlayLoader>

      <SaltoIqs
        configData={configData}
        setConfigData={setConfigData}
        saltoResources={saltoResources}
      />

      <SaltoLocks
        configData={configData}
        setConfigData={setConfigData}
        saltoResources={saltoResources}
      />

      <SaltoVisitorTypes
        configData={configData}
        setConfigData={setConfigData}
        saltoResources={saltoResources}
        visitorTypes={visitorTypes}
      />
    </StyledFlexColumn>
  );
}

export default SaltoConfigsPageView;
